module.exports = __webpack_public_path__ + "img/Clear_Lab_Up.7cdacea9.svg";